const config = {
  basename: '',
  defaultPath: '/',
  defaultId: 'question-bank',
  fontFamily: 'Google Sans Medium',
  fontSize: '16px',
  // borderRadius: 10,
};

export enum ConstantMenuSideBar {
  SYSTEM_MANAGEMENT = 'system-management',
  USER_GROUP = 'user-group',
  USER_MANAGEMENT = 'user-management',
  SURVEY_LIST = 'survey-list',
  QUESTION_BANK = 'question-bank',
  REPORT = 'report',
  SUPPORT = 'support',
}

export default config;
